export default __webpack_public_path__ + "static/media/cancel-request.b98f933e.svg";